// extracted by mini-css-extract-plugin
export var logo = "_c3-2";
export var logoWrapper = "_c3-1";
export var strip = "_c3-0";